import React from 'react';
import { HeroSectionV2 } from '../components/HeroSectionV2';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV2() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1134">
      <HeroSectionV2 data-id="element-1135" />
      <PainSection data-id="element-1136" />
      <TruthSection data-id="element-1137" />
      <ProductPresentation data-id="element-1138" />
      <ContentBreakdown data-id="element-1139" />
      <BenefitsSection data-id="element-1140" />
      <TestimonialsSection data-id="element-1141" />
      <ForYouSection data-id="element-1142" />
      <GuaranteeSection data-id="element-1143" />
      <BonusSection data-id="element-1144" />
      <ValueStack data-id="element-1145" />
      <FAQSection data-id="element-1146" />
      <ImpactPhrases data-id="element-1147" />
      <Footer data-id="element-1148" />
    </div>;
}